(function () {
  const cards = document.querySelectorAll("[data-hp-rewards-card]");

  cards.forEach((card) => {
    if (card.dataset.hpRewardsReady === "true") return;
    card.dataset.hpRewardsReady = "true";

    const dragSurface = card.closest(".hp-rewards-hero__media") || card.closest(".hp-rewards-card-scene") || card;
    const cardStyles = getComputedStyle(card);
    const readAngle = (property, fallback) => {
      const value = Number.parseFloat(cardStyles.getPropertyValue(property));
      return Number.isFinite(value) ? value : fallback;
    };
    const defaultRotateX = readAngle("--hp-card-rotate-x", 0);
    const defaultRotateY = readAngle("--hp-card-rotate-y", 0);
    const defaultRotateZ = readAngle("--hp-card-rotate-z", 0);
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const state = {
      rotateX: defaultRotateX,
      rotateY: defaultRotateY,
      rotateZ: defaultRotateZ,
      startX: 0,
      startRotateY: 0,
      activePointer: null,
      loadSpinFrame: null,
    };

    const faceAngle = () => Math.abs((((state.rotateY + 180) % 360) + 360) % 360 - 180);
    const isShowingBack = () => faceAngle() > 90;
    const isShowingSide = () => {
      const angle = faceAngle();
      return angle > 6 && angle < 174;
    };
    const dragSpeed = () => (window.matchMedia("(max-width: 640px)").matches ? 1 : 0.62);
    const easeOutQuart = (progress) => 1 - Math.pow(1 - progress, 4);

    const render = () => {
      card.style.setProperty("--hp-card-rotate-x", `${state.rotateX.toFixed(1)}deg`);
      card.style.setProperty("--hp-card-rotate-y", `${state.rotateY.toFixed(1)}deg`);
      card.style.setProperty("--hp-card-rotate-z", `${state.rotateZ.toFixed(1)}deg`);
      card.classList.toggle("is-flipped", isShowingBack());
      card.classList.toggle("is-side-on", isShowingSide());
    };

    const canStartDrag = (event) => {
      const cardRect = card.getBoundingClientRect();
      const surfaceRect = dragSurface.getBoundingClientRect();
      const padding = Math.max(84, cardRect.width * 0.18);
      const left = Math.min(cardRect.left, surfaceRect.left) - padding;
      const right = Math.max(cardRect.right, surfaceRect.right) + padding;
      const top = Math.min(cardRect.top, surfaceRect.top) - padding;
      const bottom = Math.max(cardRect.bottom, surfaceRect.bottom) + padding;

      return event.clientX >= left && event.clientX <= right && event.clientY >= top && event.clientY <= bottom;
    };

    const startDrag = (event) => {
      if (state.activePointer !== null) return;
      if (event.button !== 0 && event.pointerType === "mouse") return;
      if (!canStartDrag(event)) return;

      if (state.loadSpinFrame !== null) {
        cancelAnimationFrame(state.loadSpinFrame);
        state.loadSpinFrame = null;
      }
      state.activePointer = event.pointerId;
      state.startX = event.clientX;
      state.startRotateY = state.rotateY;
      card.classList.add("is-dragging");
      try {
        dragSurface.setPointerCapture(event.pointerId);
      } catch (error) {
        // Some browsers only allow capture on the original pointer target.
      }
    };

    const moveDrag = (event) => {
      if (state.activePointer !== event.pointerId) return;

      const deltaX = event.clientX - state.startX;

      state.rotateX = defaultRotateX;
      state.rotateY = state.startRotateY + deltaX * dragSpeed();
      state.rotateZ = defaultRotateZ;
      render();
    };

    const finishDrag = (pointerId) => {
      if (state.activePointer === null) return;

      const activePointer = state.activePointer;
      state.activePointer = null;
      card.classList.remove("is-dragging");
      if (pointerId === activePointer && dragSurface.hasPointerCapture(pointerId)) {
        dragSurface.releasePointerCapture(pointerId);
      }
    };

    const stopDrag = (event) => {
      if (state.activePointer !== event.pointerId) return;
      finishDrag(event.pointerId);
    };

    const runLoadSpin = () => {
      if (prefersReducedMotion.matches) {
        render();
        return;
      }

      const startRotateY = defaultRotateY - 1080;
      const endRotateY = defaultRotateY;
      const duration = 1720;
      let startTime = null;

      state.rotateX = defaultRotateX;
      state.rotateY = startRotateY;
      state.rotateZ = defaultRotateZ;
      render();

      const step = (time) => {
        if (state.activePointer !== null) {
          state.loadSpinFrame = null;
          return;
        }

        if (startTime === null) startTime = time;
        const progress = Math.min((time - startTime) / duration, 1);
        const eased = easeOutQuart(progress);

        state.rotateX = defaultRotateX;
        state.rotateY = startRotateY + (endRotateY - startRotateY) * eased;
        state.rotateZ = defaultRotateZ;
        render();

        if (progress < 1) {
          state.loadSpinFrame = requestAnimationFrame(step);
          return;
        }

        state.rotateY = endRotateY;
        state.loadSpinFrame = null;
        render();
      };

      state.loadSpinFrame = requestAnimationFrame(step);
    };

    dragSurface.addEventListener("pointerdown", startDrag);
    document.addEventListener("pointerdown", startDrag);
    dragSurface.addEventListener("pointermove", moveDrag);
    window.addEventListener("pointermove", moveDrag);
    dragSurface.addEventListener("pointerup", stopDrag);
    dragSurface.addEventListener("pointercancel", stopDrag);
    dragSurface.addEventListener("lostpointercapture", () => finishDrag(state.activePointer));
    window.addEventListener("pointerup", stopDrag);
    window.addEventListener("pointercancel", stopDrag);

    runLoadSpin();
  });
})();
